import {useQueryClient} from "@tanstack/react-query";

const useCacheRefresh = () => {
    const queryClient = useQueryClient();
    const refreshCache = (target) => {
        const allQueries = queryClient.getQueryCache().getAll();
        
        allQueries.forEach(({ queryKey }) => {
            if (target.includes(queryKey[1])) {
                queryClient.removeQueries(queryKey);
            }
        });
    };

    return refreshCache;
};

export {useCacheRefresh}